import { Injectable } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { BaseFormGroupService } from "../../util/components/modal/base-form-group.service";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { Observable } from "rxjs";
import { AppAbility } from "../../util/service/auth.service";
import { CaslAction } from "../../server/enums/casl-action.enum";
import { EntityTyp } from "../../util/enums/entity-typ.enum";
import { OfficeDto } from "app/api/models";
import { OfficeService } from "app/api/services";

@Injectable({
  providedIn: "root",
})
export class OfficeFormGroupService extends BaseFormGroupService<OfficeDto> {
  entitySingular = "Standort";

  constructor(
    private fb: FormBuilder,
    public override modal: NgbActiveModal,
    protected toastr: ToastrService,
    private officeService: OfficeService,
    private ability: AppAbility
  ) {
    super(modal, toastr);
  }

  initFormGroup() {
    this.formGroup = this.fb.group({
      name: ["", [Validators.required]],
      type: [null, [Validators.required]],
      version: [0, [Validators.required]],
      mandatoryReportsPerDay: [null],
    });

    this.formGroup.get("type").valueChanges.subscribe(() => {
      this.formGroup.get("mandatoryReportsPerDay").setValue(null);
    });

    this.setPermissions();
  }

  protected create(mergedEntity: OfficeDto): Observable<OfficeDto> {
    return this.officeService.officeControllerCreate({ body: mergedEntity });
  }

  protected update(mergedEntity: OfficeDto): Observable<OfficeDto> {
    return this.officeService.officeControllerUpdate({
      body: mergedEntity,
    });
  }

  protected reloadEntity(id: number): Observable<OfficeDto> {
    return this.officeService.officeControllerFindOne({ id });
  }

  protected updateFormGroup(entity: OfficeDto) {
    this.formGroup.patchValue(entity, { emitEvent: false });
    if (entity.id) {
      this.formGroup.get("type")?.disable();
    }
    this.setPermissions();
  }

  private setPermissions() {
    if (this.ability.can(CaslAction.Update, EntityTyp.Office)) {
      return;
    }
    this.formGroup.disable({ emitEvent: false });
  }
}
